import React from 'react';
import { useLocation } from 'react-router-dom';
import { matchMultiplePaths } from '../../Helper/matchMultiplePaths';
import FixedContainer from './Abstracts/FixedContainer/FixedContainer';
import NavIcons from './Abstracts/NavIcons/NavIcons';
import Main from './Main/Main';
import TopRightContents from './TopRightContents/TopRightContents';
//@ts-ignore
import style from './VirtualTradeShow.module.scss?module';
import { VtsInterface } from '../../../Interface/Vts';
import LogoImage from './Abstracts/LogoImage/LogoImage';
import GuidedTour from './Main/GuidedTour/GuidedTour';
import VtsProvider, { useVts } from '../../Context/VtsContext';
import ShowcaseArea from './Abstracts/ShowcaseArea/ShowcaseArea';
import { useAtomValue } from 'jotai';
import { startGuidedTourAtom } from './Atoms/vtsAtoms';

export const VtsContext = React.createContext<{
  vts: VtsInterface | undefined;
}>({
  vts: undefined,
});

const VirtualTradeShow = () => {
  const matchAdminPath = matchMultiplePaths(['/virtual-trade-show/admin/*']);

  return (
    <VtsProvider>
      <div
        className="vts"
        style={{ display: 'flex', flexDirection: 'column', flexGrow: '1' }}
      >
        <Main />
        {!matchAdminPath && (
          <>
            <FixedContainer position={'topLeft'}>
              <LogoImage />
            </FixedContainer>
            <FixedContainer position={'topRight'}>
              <TopRightContents />
            </FixedContainer>
            <FixedContainer position={'bottomCenter'}>
              <NavIcons />
            </FixedContainer>
            <GuidedTourPosition />

            <ShowcaseArea />
          </>
        )}
      </div>
    </VtsProvider>
  );
};
export default VirtualTradeShow;

const GuidedTourPosition = () => {
  const isGuidedTourStarted = useAtomValue(startGuidedTourAtom);
  const location = useLocation();
  const { vts } = useVts();

  return (
    <FixedContainer
      className={style.GuidedTourContainer}
      position="bottomCenter"
    >
      {location.pathname === '/virtual-trade-show/lobby' &&
        ((vts && vts && !vts.is_guided_tour_viewed) || isGuidedTourStarted) && (
          <GuidedTour />
        )}
    </FixedContainer>
  );
};
